import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { FiAlertTriangle, FiChevronRight } from "react-icons/fi";
import SimpleModal from "components/Modal/SimpleModal";
import "./PlanMissingContractModal.scss";

const employeeLabel = (employee) =>
	`${employee?.name || ""} ${employee?.surname || ""}`.trim();

const PlanMissingContractModal = ({
	isOpen,
	entries = [],
	onClose,
	onAssignContract,
}) => {
	const { t } = useTranslation();

	if (!isOpen || entries.length === 0) return null;

	return (
		<SimpleModal
			isOpen={isOpen}
			onClose={onClose}
			className="plan-missing-contract-modal"
		>
			<div className="plan-missing-contract">
				<div className="plan-missing-contract__icon" aria-hidden="true">
					<FiAlertTriangle />
				</div>
				<h2 className="plan-missing-contract__title">
					{t("plan.error.missingContractTitle")}
				</h2>
				<p className="plan-missing-contract__intro">
					{t("plan.error.missingContractIntro")}
				</p>
				<ul className="plan-missing-contract__list">
					{entries.map(({ employee, day }) => (
						<li key={`${employee.id}-${day}`}>
							<button
								type="button"
								className="plan-missing-contract__row"
								onClick={() => onAssignContract(employee, day)}
							>
								<span className="plan-missing-contract__row-text">
									<span className="plan-missing-contract__name">
										{employeeLabel(employee)}
									</span>
									<span className="plan-missing-contract__date">
										{moment(day).format("DD/MM/YYYY")}
									</span>
								</span>
								<span className="plan-missing-contract__action">
									{t("plan.error.missingContractAction")}
									<FiChevronRight aria-hidden="true" />
								</span>
							</button>
						</li>
					))}
				</ul>
				<button
					type="button"
					className="btn btn-light plan-missing-contract__dismiss"
					onClick={onClose}
				>
					{t("common.understood")}
				</button>
			</div>
		</SimpleModal>
	);
};

export default PlanMissingContractModal;
